module.exports = __webpack_public_path__ + "img/mt8.e3a1aee0.jpg";